import { ArrowDownIcon, ArrowUpIcon } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { UsageComparison } from "@/components/usage-comparison";
import { hasUsageTrend, type UsageChange } from "@/lib/usage-comparison";

interface UsageStatCardProps {
  title: string;
  value: string;
  description: string;
  comparison: UsageChange;
  period: string;
  valueLoading?: boolean;
  comparisonLoading?: boolean;
}

export function UsageStatCard({
  title, value, description, comparison, period, valueLoading, comparisonLoading,
}: UsageStatCardProps) {
  const loading = valueLoading || comparisonLoading;
  return (
    <Card aria-busy={loading} className="bg-gradient-to-br from-purple-50 to-pink-50 border border-purple-100">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-purple-900">{title}</CardTitle>
        {!loading && hasUsageTrend(comparison) && (comparison.changeType === "increase"
          ? <ArrowUpIcon aria-hidden="true" className="h-4 w-4 text-green-600" />
          : <ArrowDownIcon aria-hidden="true" className="h-4 w-4 text-red-600" />)}
      </CardHeader>
      <CardContent>
        {valueLoading ? <div aria-hidden="true" className="h-8 w-16 bg-purple-200 animate-pulse rounded mb-2" /> : (
          <div className="text-2xl font-bold text-purple-900">{value}</div>
        )}
        <p className="text-xs text-purple-700/80">{description}</p>
        <UsageComparison comparison={comparison} period={period} loading={loading} />
      </CardContent>
    </Card>
  );
}
